import { actionTypes } from '../../constants/actionTypes';

export interface ISetVisibleStickHeaderAction {
  type: actionTypes.SET_VISIBLE_STICK_HEADER;
  payload: boolean;
}

export type TStickHeaderActions = ISetVisibleStickHeaderAction;

export function setVisibleStickHeader(isVisible: boolean): ISetVisibleStickHeaderAction {
  return {
    type: actionTypes.SET_VISIBLE_STICK_HEADER,
    payload: isVisible,
  };
}
